import { FieldInput, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Vehicle } from 'types/generatedSchemaTypes';

type NameInputProps = {
  name: string;
  setName: (values: Partial<Vehicle>) => void;
};

const VehicleNameInput = ({ name, setName }: NameInputProps) => {
  const { t } = useTranslation();

  return (
    <FieldInput
      title={t('onboarding.nickname')}
      value={name}
      placeholder={t('onboarding.giveVehicleNickname')}
      placeholderTextColor={theme.colors.gray300}
      onChangeText={(value) => setName({ name: value })}
      testID="name-input"
    />
  );
};

export default React.memo(VehicleNameInput);
